// @ts-nocheck
import React, { useState } from 'react';
import {
  loadPlatforms,
  exportPlatformData,
} from '../../../../actions/platformActions';
import { NavLink, useLocation } from 'react-router-dom';
import { Table, SimpleTextFilter, getVisibleColumns } from '../../../common/Table';
import { CommaNumber_NoDecimal, hexToRgbA } from '../../../../util/formatter';
import Loading from '../../../common/Loading';
import KwPanel from '../../../common/KwPanel';
import {
  useTableSettings,
  getTableSettingsDefaults,
} from '../../../../hooks/useTableSettings';
import PlatformLink from '../../../common/links/PlatformLink';
import { useTranslation } from 'react-i18next';
import { scopes as tableScopes } from '../../../../constants/scopes';

function PlatformList({ reload }) {
  const { t } = useTranslation();
  const allColumns = ['name', 'gameCount', 'requestCount'];
  const defaultVisibleColumns = allColumns;
  const [platforms, setPlatforms] = useState();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const { tableSettings, handleSetTableSettings: setTableSettings, filters, filterChange, isLoading } =
    useTableSettings(
      'platformlist-settings',
      getTableSettingsDefaults({ defaultSort: 'name', defaultVisibleColumns }),
      null,
      loadPlatforms,
      setPlatforms,
      reload,
      t('Failed to load platforms')
    );

  // The base config of the columns, this will be filtered based on the visible (above)
  let columnsConfig = [
    {
      Key: 'name',
      Label: t('Name'),
      className: 'flush',
      width: '40%',
      Render: (platform) => (
        <div
          className="p-2 d-flex align-items-center company-td"
          style={
            platform.colourHex
              ? {
                  borderLeft: `3px solid ${platform.colourHex}`,
                }
              : null
          }
        >
          <PlatformLink
            id={platform.id}
            name={platform.name}
            imageId={platform.imageId}
            imageSize={32}
          />
        </div>
      ),
      Filter: {
        Render: (col) => (
          <SimpleTextFilter
            Key={col.Key}
            Value={col.filterValue ?? params.get(`f_${col.Key}`) ?? ''}
            onChange={(value) => filterChange(col.Key, value)}
            testId="platform-name-filter"
          />
        ),
      },
    },
    {
      Key: 'gameCount',
      Label: t('Number of games'),
      width: '30%',
      className: 'text-right num no-wrap',
      //Render: (platform) => CommaNumber_NoDecimal(platform.gameCount),
      Render: (platform) => (
        <NavLink to={`/games?${tableScopes.PLATFORM}=${platform.id}`}>
          {CommaNumber_NoDecimal(platform.gameCount)}
        </NavLink>
      ),
    },
    {
      Key: 'requestCount',
      Label: t('Number of requests'),
      width: '30%',
      className: 'text-right num no-wrap',
      //Render: (platform) => CommaNumber_NoDecimal(platform.requestCount),
      Render: (platform) => (
        <NavLink to={`/requests/all?s_platform=${platform.id}`}>
          {CommaNumber_NoDecimal(platform.requestCount)}
        </NavLink>
      ),
    },
  ];

  // filter
  const visibleColumns = tableSettings.columns ?? defaultVisibleColumns;
  const columns = getVisibleColumns(visibleColumns, columnsConfig);

  // return an alaska table
  return platforms ? (
    <KwPanel className="mb-4">
      <Table
        columns={columns}
        allColumns={allColumns}
        rows={platforms.data.map((x) => {
          return { Key: x.id, ...x };
        })}
        totalRowCount={platforms.totalRowCount}
        filteredRowCount={platforms.filteredRowCount}
        tableSettings={tableSettings}
        setTableSettings={setTableSettings}
        isLoading={isLoading}
        filters={filters}
        filterChange={filterChange}
        trStyle={(row) => {
          return {
            backgroundColor: `${hexToRgbA(row.colourHex, 0.0375)}`,
          };
        }}
        exportData={exportPlatformData}
      />
    </KwPanel>
  ) : (
    <Loading></Loading>
  );
}

export default PlatformList;
